import styled from "styled-components";

const HomeCriminalsWrap = styled.div`
  padding: 9px 0 0px 0;
`

export default HomeCriminalsWrap
